import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/multiLocationSagas";
import MultiSelectDropdown from "../../../components/multiSelectDropdown/multiSelectDropdown";

const RevenueType = () => {
  const dispatch = useDispatch();
  const { filters, label, value } = useSelector((state) => state.multiLocation.revenueType);

  return (
    <div className="select-box revenue-type-filter" style={{ width: 130 }}>
      <p>{label}</p>
      <MultiSelectDropdown
        options={filters}
        selectedFilters={value}
        placeholder="Select group"
        includeFilter={false}
        onSelectChange={(data) => dispatch(actionCreators.updateRevenueType(data))}
      />
    </div>
  );
};

export default RevenueType;
